import { useMutation } from "react-query";
import { toast } from "react-toastify";
import { getRegisterMessage, verifyRegisterMessage } from "../api";

export function useGetRegisterMessage(address: string, proxy_link: string) {
    const { mutateAsync } = useMutation(() => getRegisterMessage(address, proxy_link), {
        onError(error: any) {
            if (error.response.data) toast.error(error.response.data, { autoClose: 5000 })
            else if (error instanceof Error) toast.error(error.message, { autoClose: 5000 })
            else {
                toast.error('Errors while registering. Please check and try again.', { autoClose: 5000 })
            }
        },
    });
    return { getMessage: mutateAsync };
};

export function useVerifyRegisterMessage() {
    const { mutateAsync } = useMutation(verifyRegisterMessage, {
        onSuccess(data) {
            localStorage.setItem('session', data.data);
            toast.success('Logged In Successfully!', { autoClose: 5000 })
        },
        onError(error: any) {
            localStorage.removeItem('session');
            if (error.response.data) toast.error(error.response.data, { autoClose: 5000 })
            else if (error instanceof Error) toast.error(error.message, { autoClose: 5000 })
            else {
                toast.error('Errors while verifying request. Please check and try again.', { autoClose: 5000 })
            }
        },
    });
    return { verifyMessage: mutateAsync };
};
